
import u from "umbrellajs"
import EventEmitter from "eventemitter3"


interface Selector {
  close_btn:  string
  full_btns:  string
  overlay:    string
}

export interface InputSelector {
  close_btn?:  string
  full_btns?:  string
  overlay?:    string
}

const default_selector = {
  close_btn:  ".cell--new-development-buildings--pictures-and-map-browser--tabbed__overlay__btn-close",
  full_btns:  ".cell--new-development-buildings--pictures-and-map-browser--tabbed__btn-make-full-screen",
  overlay:    ".cell--new-development-buildings--pictures-and-map-browser--tabbed__overlay",
}


/* eslint-disable no-unused-vars */
export enum EventTypes {
  MODE_SWITCHED = "switch_mode:mode_switched"
}
/* eslint-enable no-unused-vars */


class OverlayToggle extends EventEmitter<EventTypes> {
  protected selector: Selector

  protected $close_btn: UmbrellaInstance
  protected $full_btns: UmbrellaInstance
  protected $overlay: UmbrellaInstance

  constructor(selector?: InputSelector) {
    super()

    this.selector = Object.assign({}, default_selector, selector)

    this.$close_btn = u(this.selector.close_btn)
    this.$full_btns = u(this.selector.full_btns)
    this.$overlay = u(this.selector.overlay)

    this.bind_action()
  }

  protected bind_action(){
    this.$close_btn.on("click", () => {
      this.onCloseClick()
    })
    this.$full_btns.on("click", () => {
      this.onFullClick()
    })
  }
  private onCloseClick(){
    this.$overlay.each((el) => {
      el.style.display = "none"
    })
  }
  private onFullClick(){
    this.$overlay.each((el) => {
      el.style.display = "inline-block"
    })
    this.emit(EventTypes.MODE_SWITCHED)
  }
}


export {
  OverlayToggle,
}
